import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getInstructions } from './common/task-utility';
import { InstructionVideo, InstructionComicStrip } from './instructions';
import { instructionImages } from '../../assets/instruction-images';


class AssessmentInstruction extends Component {
	constructor(props) {
		super(props);

		this.state = {
			instructions: null,
			showComicStrip: false
		};

		this.handleKeydown = this.handleKeydown.bind(this);
	}

	componentDidMount(){
		const { grade, versionID } = this.props;
		const instructions = getInstructions(grade, versionID);
		this.preloadComicStrip(instructions);
		this.setState({instructions});
		window.addEventListener('keydown', this.handleKeydown);
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.handleKeydown);
	}

	preloadComicStrip(instructions) {
		const img = new Image();
		img.src = instructionImages[instructions];
	}

	handleKeydown(e, key = null) {
		if ((!!e && e.repeat) || (!e && !key)) {
			return;
		}

		if ((key && key === 'k') || (!!e && e.altKey && (e.code === 'KeyK' || e.which === 75))) {
			this.setState({showComicStrip: true}, () => {
				window.removeEventListener('keydown', this.handleKeydown);
			});
		}
	}

	render() {
		const { instructions, showComicStrip } = this.state;

		if (!instructions) {
			return null;
		}

		if (showComicStrip) {
			return <InstructionComicStrip {...this.props} instructions={instructions} />
		}

		return <InstructionVideo {...this.props} instructions={instructions} handleMobileKeydown={this.handleKeydown} />
	}
}

const mapStateToProps = state => ({
	grade: state.data.userData.grade
});

export default connect(mapStateToProps, null)(AssessmentInstruction);
